import React from 'react'
import { toAbsoluteUrl } from '../../../../../_metronic/_helpers'
import { getStatus } from '../../utils/getStatus'
import { getStatusText } from '../../utils/getStatusText'

type StatusType = 'pending' | 'success' | 'fail' | string

type StatusProps = {
  color: string
  icon: string
}

export function StatusColumnFormatter(
  status: StatusType,
  statusText?: any
): JSX.Element {

  const getProps = (): StatusProps => {
    switch (status) {
      case 'pending':
        return {
          color: '#F9C70C',
          icon: '/media/svg/Repeat_yellow.svg'
        }
      case 'success':
        return {
          color: '#28a745',
          icon: '/media/svg/Check.svg'
        }
      case 'fail':
        return {
          color: '#dc3545',
          icon: '/media/svg/Cross.svg'
        }
      default:
        return {
          color: '#000',
          icon: ''
        }
    }
  }

  const props = getProps()

  return (
    <div className="font-weight-bolder font-size-lg" style={{ color: props.color }}>
      <div className="text-nowrap">
        {props.icon && (
          <img
            src={toAbsoluteUrl(props.icon)}
            alt="icon"
            className="mr-2"
          />
        )}
        {getStatus(status)}
      </div>
      <div className="text-wrap">
        {getStatusText(statusText)}
      </div>
    </div>
  )
}